import { Avatar, Box, Menu, MenuItem, Typography } from "@mui/material";
import React, { useState } from "react";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useAppSelector } from "src/redux/hooks";
import { getAuthState } from "src/redux/slices/authSlice";
import { AccountPopover } from "./AccountPopover";

const UserProfileHeader: React.FC = () => {
  const { userName } = useAppSelector(getAuthState);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        backgroundColor: "white",
        padding: "6px 12px",
        borderRadius: "25px",
        boxShadow: 1,
      }}
    >
      <Box
        sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
        onClick={handleMenuClick}
      >
        <Typography
          sx={{ fontWeight: "bold", color: "#002D62", fontSize: "14px", mr: 1 }}
        >
          {userName}
        </Typography>
        <ExpandMoreIcon sx={{ color: "#002D62" }} />
      </Box>

      <Avatar src="" sx={{ width: 32, height: 32, ml: 1 }} />

      <AccountPopover
        username={userName ?? ""}
        anchorEl={anchorEl}
        onClose={handleClose}
        open={open}
      />
    </Box>
  );
};

export default UserProfileHeader;
